import { cn } from '@/lib/cn';
import logo from '@/brand/assets/Lendaris-_Website_Logo.svg';

export function Lockup({ className }: { className?: string }) {
  return (
    <a href="/" aria-label="Lendaris home" className="inline-flex items-center shrink-0">
      <img src={logo} alt="Lendaris" className={cn('block w-auto h-10', className)} />
    </a>
  );
}
